const HOSTAPI = process.env.REACT_APP_BASE_URL;

const uploadToS3 = async (file: File, fileName: string, fileType: string, eventId: string) => {
    try {
      // Step 1: Get the pre-signed upload URL
      const response = await fetch(`${HOSTAPI}/events/${eventId}/getVirtualUploadUrl`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ fileName, fileType }),
      });
  
      const data = await response.json();
  
      if (data.status === "success") {
        const { uploadUrl, key } = data;
  
        // Step 2: Upload the file directly to S3 using the pre-signed URL
        const uploadResponse = await fetch(uploadUrl, {
          method: "PUT",
          headers: {
            "Content-Type": fileType,
          },
          body: file,
        });
  
        if (!uploadResponse.ok) {
          throw new Error("Failed to upload to S3");
        }
  
        // Step 3: Save the virtual background details
        const saveResponse = await fetch(`${HOSTAPI}/events/${eventId}/saveVirtualBackground`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ fileName, key }),
        });
  
        const saveData = await saveResponse.json();
  
        if (saveData.status === "success") {
          return { success: true, saveData };
        } else {
          throw new Error("Failed to save virtual background");
        }
      } else {
        throw new Error("Failed to get upload URL");
      }
    } catch (error) {
      console.error(error);
      return { success: false, error: error };
    }
  };
  
  export default uploadToS3;
  